import React, { useContext, useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { AppContext } from "../../Contexts/AppContext";
import * as IoIcons from "react-icons/io";
import * as BiIcons from "react-icons/bi";
import * as MdIcons from "react-icons/md";
const Information = () => {
  const context = useContext(AppContext);

  const [currentBG, setCurrentBG] = useState("");
  const [currentText, setCurrentText] = useState("");
  const [currentColor, setCurrentColor] = useState("");
  const [isCopied, setIsCopied] = useState(false);

  useEffect(() => {
    setCurrentBG(
      context.isLight
        ? context.currentTheme["default"].bg
        : context.currentTheme["default"].dark_bg
    );
    setCurrentText(
      context.isLight
        ? context.currentTheme["default"].text
        : context.currentTheme["default"].dark_text
    );
    setCurrentColor(
      context.isLight
        ? context.currentTheme["default"].dropdown
        : context.currentTheme["default"].dark_dropdown
    );
  }, [context]);
  return (
    <div
      className="flex flex-wrap justify-center pt-14 pb-14 transition-all duration-500 ss:pb-20 ss:pt-20 lg:pt-32 lg:pb-32"
      style={{ backgroundColor: currentBG, color: currentText }}
    >
      <section
        className="m-3 mx-5 flex h-56 w-full flex-col items-center rounded border-[1px] p-3 transition-all duration-500 xs:mx-0 xs:w-72 ss:m-5 ss:h-64 ss:w-80 ss:rounded-lg ss:p-5 md:h-80 md:w-96"
        style={{
          backgroundColor: currentColor,
          color: currentText,
          borderColor: !context.isLight && currentColor,
        }}
      >
        <IoIcons.IoMdCall
          className="rounded-[100%] p-2 text-5xl"
          style={{
            backgroundColor: context.isLight ? currentText : currentBG,
            color: context.isLight ? currentColor : currentText,
          }}
        />
        <h2 className="mt-1 mb-2 text-base font-semibold ss:mb-3 ss:text-lg md:mb-5 md:text-xl">
          Call Us
        </h2>
        <p className="text-center text-xs ss:text-sm md:text-base">
          Call us to speak to a member of our team. We are always happy to help.
        </p>
        <button
          value="+961 81 789 581"
          className="relative mt-5 font-bold text-blue-500 hover:underline"
          onClick={(e) => {
            setIsCopied(true);
            navigator.clipboard.writeText(e.target.value);
            setTimeout(() => setIsCopied(false), 2000);
          }}
        >
          +961 81 789 581
          <AnimatePresence>
            {isCopied && (
              <motion.div
                initial={{
                  opacity: 0,
                }}
                animate={{
                  opacity: 1,
                  transition: {
                    duration: 0.5,
                    ease: "easeInOut",
                  },
                }}
                exit={{
                  opacity: 0,
                  transition: {
                    duration: 0.2,
                    ease: "easeInOut",
                  },
                }}
                className="absolute top-[150%] left-1/2 flex translate-x-[-50%] items-center justify-center rounded bg-green-500 px-2 py-1 text-white xs:left-[115%] xs:top-1/2 xs:translate-x-[0%] xs:translate-y-[-50%]"
              >
                <div className="absolute top-[-45%] border-r-[15px] border-b-[15px] border-l-[15px] border-l-transparent border-r-transparent border-b-green-500 xs:left-0 xs:top-auto xs:translate-x-[-70%] xs:rotate-[-90deg]"></div>
                <IoIcons.IoMdCheckboxOutline className="mr-1 text-xl" /> Copied
              </motion.div>
            )}
          </AnimatePresence>
        </button>
      </section>
      <section
        className="m-3 mx-5 flex h-56 w-full flex-col items-center rounded border-[1px] p-3 transition-all duration-500 xs:mx-0 xs:w-72 ss:m-5 ss:h-64 ss:w-80 ss:rounded-lg ss:p-5 md:h-80 md:w-96"
        style={{
          backgroundColor: currentColor,
          color: currentText,
          borderColor: !context.isLight && currentColor,
        }}
      >
        <BiIcons.BiMapPin
          className="rounded-[100%] p-2 text-5xl"
          style={{
            backgroundColor: context.isLight ? currentText : currentBG,
            color: context.isLight ? currentColor : currentText,
          }}
        />
        <h2 className="mt-1 mb-2 text-base font-semibold ss:mb-3 ss:text-lg md:mb-5 md:text-xl">
          Our Location
        </h2>
        <iframe
          title="Location"
          className="h-2/4 w-full rounded-lg shadow-[0_0_8px_0_#0004] md:h-3/5"
          src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1000.0850857829056!2d35.50414978512166!3d33.89403413809424!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x151f16e142563ebb%3A0xad8fa77b2ab4eb91!2sRegus%20-%20Beirut%20Azariyah!5e0!3m2!1sen!2slb!4v1665243492927!5m2!1sen!2slb"
          loading="lazy"
        ></iframe>
      </section>
      <section
        className="m-3 mx-5 flex h-56 w-full flex-col items-center rounded border-[1px] p-3 transition-all duration-500 xs:mx-0 xs:w-72 ss:m-5 ss:h-64 ss:w-80 ss:rounded-lg ss:p-5 md:h-80 md:w-96"
        style={{
          backgroundColor: currentColor,
          color: currentText,
          borderColor: !context.isLight && currentColor,
        }}
      >
        <MdIcons.MdSupport
          className="rounded-[100%] p-2 text-5xl"
          style={{
            backgroundColor: context.isLight ? currentText : currentBG,
            color: context.isLight ? currentColor : currentText,
          }}
        />
        <h2 className="mt-1 mb-2 text-base font-semibold ss:mb-3 ss:text-lg md:mb-5 md:text-xl">
          Support
        </h2>
        <p className="text-center text-xs ss:text-sm md:text-base">
          Email us for general queries, including marketing and partnership
          opportunities.
        </p>
        <button
          className="mt-5 rounded-lg border-2 py-1 px-2 text-sm transition-all ss:py-2 ss:px-4 md:text-base"
          style={{ backgroundColor: currentText, color: currentColor }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = "unset";
            e.target.style.color = "unset";
            e.target.style.borderColor = "unset";
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = currentText;
            e.target.style.color = currentColor;
          }}
        >
          Support
        </button>
      </section>
    </div>
  );
};

export default Information;
